export default __webpack_public_path__ + "static/media/fancyCaractor.600b12ee.jpeg";